/**
 * Platform detection for the Ship-to-phone dialog. Lives in its own
 * file so the React fast-refresh boundary inside `ShipDialog.tsx`
 * stays component-only.
 */

export type DetectedPlatform = 'ios' | 'android' | 'desktop';

/** Best-effort UA-based platform detection. Fine for steering the
 *  highlighted card; the kid sees all three regardless. */
export function detectPlatform(ua: string = navigator.userAgent): DetectedPlatform {
  if (/iPhone|iPad|iPod/.test(ua)) return 'ios';
  if (/Android/.test(ua)) return 'android';
  return 'desktop';
}
